var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"relative overflow-hidden",style:(("height: " + _vm.containerHeight + "; width: " + _vm.width + ";"))},[_vm._t("before-map"),_vm._v(" "),_c('div',{attrs:{"id":"google-map-area"}}),_vm._v(" "),_vm._t("after-map")],2)}
var staticRenderFns = []

export { render, staticRenderFns }